import styled from 'styled-components';
import { FontSizes, LinkSmall } from '../typography/typography.styles';
import { BREAKPOINTS } from '../../constants/breakpoints';

export const ModalCrossSaleContainer = styled.div`
  .textContentWrapper {
    padding: 2.4rem 4rem 3.2rem 4rem;
    @media (max-width: ${BREAKPOINTS.mobile.css}) {
      padding: 2rem 1.6rem;
    }
  }

  h2 {
    font-size: ${FontSizes.mediumBig};

    @media (max-width: ${BREAKPOINTS.mobile.css}) {
      text-align: left !important;
      font-size: ${FontSizes.mediumPlus};
      line-height: 2.4rem;
    }
  }

  .text {
    color: ${({ theme }) => theme.colors.baseColors.grey100};
    font-size: ${FontSizes.normal};
    font-weight: 500;
    line-height: 2rem;
    letter-spacing: 0.5px;
    margin: 1.2rem 0 2.4rem 0;

    @media (max-width: ${BREAKPOINTS.mobile.css}) {
      margin: 0.4rem 0 2.4rem 0;
    }
  }

  .links {
    text-align: center;
    font-size: 1rem;
    line-height: 1.4rem;
    font-weight: 400;
    letter-spacing: 0;
    color: ${({ theme }) => theme.colors.baseColors.grey100};

    ${LinkSmall} {
      font-size: 1rem;
      line-height: 1.4rem;
      font-weight: 400;
      letter-spacing: 0;
    }
  }
`;
